// Used by the route's validateSearch outside the lazy page chunk, so this module stays free of components.

// German keys: they appear in shared links (?tab=leistung), like the other German paths.
export const PERSON_TABS = ['ueberblick', 'leistung', 'training', 'gesundheit', 'vertrag', 'notizen', 'stammdaten'] as const
export type PersonTab = (typeof PERSON_TABS)[number]
